import React from "react";

const QuizCompleted: React.FC = () => {
  return (
    <div className="flex flex-col h-full items-center justify-center px-4 text-center">
      <h1 className="text-[32px] primary-color leading-[42px] font-semibold">
        Congratulations!
      </h1>
      <p className="text-[16px] text-[#000000] mt-2">
        You have already completed this automation.
      </p>
    </div>
  );
};

export default QuizCompleted;
